module.exports = __webpack_public_path__ + "7f04788d0d8b155c3c9520c478b853ec.pdf";